import { render } from "./ModalModifierTypesDonnees.vue?vue&type=template&id=67ce49e9"
import script from "./ModalModifierTypesDonnees.vue?vue&type=script&lang=js"
export * from "./ModalModifierTypesDonnees.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__